import { jsx as n, Fragment as f, jsxs as a } from "react/jsx-runtime";
import { useCallback as u, useState as g, useRef as C, useEffect as D } from "react";
import { createPortal as M } from "react-dom";
import e from "./styles.module.less.js";
import { MenuItem as N } from "../menu-item/index.js";
import k from "../close.svg2.js";
import L from "../menu-dropdown-wrapper.svg.js";
import b from "../menu-dropdown-wrapper-mobile.svg.js";
import T from "../chevron-right.svg.js";
import { useDisableScroll as E } from "../../../../utils/use-disable-scroll.js";
import { IMAGE_BASE_PATH as S } from "../../../../constants.js";
const A = `${S}/default-area-of-law.webp`, P = (w) => {
  const { language: I, isActive: c, hasShrunk: $, items: s, titleLabel: o, link: h, classNames: i } = w, v = u(() => {
    window.location.href = h;
  }, [I]), [d, m] = g(
    null
  ), p = C(null), l = u((t) => {
    p.current && clearTimeout(p.current), m(t);
  }, []), r = u(() => {
    p.current = setTimeout(() => {
      m(null);
    }, 300);
  }, []);
  return /* @__PURE__ */ n(
    N,
    {
      label: o ?? "",
      chevronStyle: "rotate",
      hasShrunk: $,
      isActive: c,
      onClick: v,
      classNames: {
        labelContainer: e.menuItemContainer,
        childContainer: e.menuItemDropdown
      },
      children: /* @__PURE__ */ n(f, { children: /* @__PURE__ */ a(
        "div",
        {
          className: `${e.innerWrapper} ${(i == null ? void 0 : i.container) ?? ""}`,
          children: [
            /* @__PURE__ */ n("div", { className: e.dropdownGrid, children: s.map((t) => /* @__PURE__ */ a(
              "a",
              {
                className: `${e.menuDropdownItem} ${(i == null ? void 0 : i.itemRow) ?? ""}`,
                href: t.path,
                onMouseEnter: () => l(t),
                onMouseLeave: r,
                children: [
                  /* @__PURE__ */ n("div", { className: e.menuDropdownItemTitle, children: t.title }),
                  /* @__PURE__ */ n("div", { className: e.menuDropdownItemDescription, children: t.description })
                ]
              },
              t.title
            )) }),
            /* @__PURE__ */ n("div", { className: e.dropdownImageWrapper, children: /* @__PURE__ */ a("div", { className: e.areaOfLawImageContainer, children: [
              /* @__PURE__ */ n(L, { className: e.menuDropdownBGIcon }),
              /* @__PURE__ */ n(
                "img",
                {
                  src: `${d ? d.image : A}`,
                  alt: "active-item-image",
                  className: `${e.areaOfLawImage} ${e.currentImage} ${d ? "" : e.defaultImage}`
                }
              )
            ] }) })
          ]
        }
      ) })
    }
  );
}, H = (w) => {
  const { items: I, titleLabel: c, link: $, iconComponent: s, classNames: o, children: h } = w, [i, v] = g(!1), [d, m] = g(!1);
  E({ isDisabled: i });
  const p = u(() => {
    v(!0);
  }, []), l = u(() => {
    m(!0), setTimeout(() => {
      v(!1), m(!1);
    }, 150);
  }, []);
  return D(() => (window.addEventListener("resize", l), () => {
    window.removeEventListener("resize", l);
  }), [l]), /* @__PURE__ */ a(f, { children: [
    /* @__PURE__ */ n("div", { className: e.headingContainer, onClick: p, children: h || (c ? /* @__PURE__ */ a(f, { children: [
      /* @__PURE__ */ n(
        "div",
        {
          className: `${e.mainMenuLink} ${(o == null ? void 0 : o.mainMenuLink) ?? ""} `,
          children: c
        }
      ),
      /* @__PURE__ */ n(T, { className: e.arrowIcon })
    ] }) : null) }),
    i ? M(
      /* @__PURE__ */ a(
        "div",
        {
          className: `${e.areasMenuModal} ${o == null ? void 0 : o.container}`,
          children: [
            /* @__PURE__ */ a("div", { className: e.closeWrapper, children: [
              /* @__PURE__ */ n(
                k,
                {
                  className: `${e.closeButton} ${e.activeIcon} ${d ? e.hidden : ""}`,
                  onClick: l
                }
              ),
              typeof s == "function" ? s(i) : s
            ] }),
            /* @__PURE__ */ a("div", { className: e.modalContent, children: [
              /* @__PURE__ */ n("a", { href: $, className: e.headingContainer, children: /* @__PURE__ */ n("div", { className: `${e.mainMenuLink} ${e.pageTitle}`, children: c }) }),
              /* @__PURE__ */ n("div", { className: e.areasList, children: I.map((r) => {
                const t = /* @__PURE__ */ a(f, { children: [
                  /* @__PURE__ */ a("div", { className: e.menuDropdownItemTitleWrapper, children: [
                    /* @__PURE__ */ n(
                      "div",
                      {
                        className: `${e.menuDropdownItemTitle} ${r.isGradient ? e.gradientText : ""}`,
                        children: r.title
                      }
                    ),
                    r.icon
                  ] }),
                  /* @__PURE__ */ n("div", { className: e.menuDropdownItemDescription, children: r.description })
                ] });
                if (r.path)
                  return /* @__PURE__ */ n(
                    "a",
                    {
                      className: `${e.menuDropdownItem} ${(o == null ? void 0 : o.itemRow) ?? ""}`,
                      href: r.path,
                      children: t
                    },
                    r.title
                  );
                if (r.onClick)
                  return /* @__PURE__ */ n(
                    "div",
                    {
                      className: `${e.menuDropdownItem} ${(o == null ? void 0 : o.itemRow) ?? ""}`,
                      onClick: r.onClick,
                      children: t
                    },
                    r.title
                  );
              }) }),
              /* @__PURE__ */ n(b, { className: e.mobileBGIcon })
            ] })
          ]
        }
      ),
      document.body
    ) : null
  ] });
};
export {
  P as DropdownMenuItemDesktop,
  H as DropdownMenuItemMobile
};
